import { PhoneType } from './eums/phoneType';
import { EmailType } from './eums/emailType';
import { PersonModel } from './personModel';

export interface RegisterPersonModel extends PersonModel {
  password?: string;
}

export const registerPersonBlankObj: RegisterPersonModel = {
  coms: {
    phoneNumbers: [{ phoneType: PhoneType.Primary, phoneNumber: '' }],
    emailAddresses: [{ emailType: EmailType.Primary, emailAddress: '' }],
  },
};
